// extracted by mini-css-extract-plugin
export default {"bgImage":"about_bgImage__LEftH"};